export const SELECTORS = {
	rideshare: '.rideshare',
	scroll: '.rideshare__trigger--scroll-up',
	toggle: 'button.rideshare__trigger',
	item: '.rideshare__item',
	itemTrigger: '.rideshare__item .rideshare__trigger',
	footer: 'footer.footer',
};

export const CLASSES = {
	scrolling: 'rideshare--scrolling',
	scrollTop: 'rideshare--scroll-top',
	scrollBottom: 'rideshare--scroll-bottom',
	itemOpened: 'rideshare__item--opened',
	itemClosing: 'rideshare__item--closing',
};
